import { FormattedMessage } from "react-intl";

import { DEFAULT_VALUES, useLocalizedHref } from "@/libraries/web-framework";
const UnlimitedAutomations = () => {
    const localizedHref = useLocalizedHref("/software/confluence/automation");
    return (
        <div>
            <p>
                <FormattedMessage
                    id="ConfluencePricingPageTeam24.features.unlimitedAutomations.content.body"
                    defaultMessage="Increase efficiency by replacing manual, time-consuming work with automated processes and workflows. <a>Learn more.</a>"
                    values={{
                        ...DEFAULT_VALUES,
                        a: (chunks) => (
                            <a
                                data-event="clicked"
                                data-event-component="linkButton"
                                data-product-key="confluence"
                                data-track-event="ConfluencePricingPageTeam24.unlimitedAutomations.learnMore"
                                data-event-container="ConfluencePriceFinderTeam24"
                                data-label-english="learn more"
                                href={localizedHref}
                            >
                                {chunks}
                            </a>
                        )
                    }}
                />
            </p>
        </div>
    );
};
export default UnlimitedAutomations;
